import { render, staticRenderFns } from "./ArTurnover.vue?vue&type=template&id=bb777492&scoped=true"
import script from "./ArTurnover.vue?vue&type=script&lang=js"
export * from "./ArTurnover.vue?vue&type=script&lang=js"
import style0 from "./ArTurnover.vue?vue&type=style&index=0&id=bb777492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb777492",
  null
  
)

export default component.exports